import { FC, useEffect } from "react";
import close from "../../../images/close.svg";

const EmergencyDisclaimer: FC<EmergencyDisclaimerProps> = ({
  onAccept,
  onClose,
}) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [onClose]);

  return (
    <div className="flex flex-col items-center text-center w-[calc(100%-48px)] max-w-[420px] sm:w-[490px] sm:max-w-[490px] bg-white py-[57.5px] px-8 xs:px-[35.5px] rounded-[20px] relative text-gray-7">
      <img
        className="absolute top-8 right-[26px] cursor-pointer"
        src={close}
        alt="close"
        onClick={onClose}
      />

      <h1 className="font-extrabold text-[32px] leading-[38px] xs:text-[50px] xs:leading-[52px] mb-4 xs:mb-10">
        Emergency Disclaimer
      </h1>
      <p className="font-[400] text-[14px] leading-[18px] xs:text-base xs:leading-[20px] mb-10">
        This platform is exclusively for anonymous reporting of non-emergency
        incidents. For immediate danger or emergencies, please call 911. Your
        safety is our top priority, and we encourage you to seek immediate
        assistance from the appropriate authorities for urgent situations.
      </p>
      <button
        className="bg-gray-7 text-white font-[900] rounded-[24px] py-[15px] max-w-[calc(100%-64px)] w-[305px] text-base leading-[20px] xs:text-[18px] xs:leading-[22px]"
        onClick={onAccept}
      >
        Agreed
      </button>
    </div>
  );
};

export default EmergencyDisclaimer;

interface EmergencyDisclaimerProps {
  onAccept: () => void;
  onClose: () => void;
}
